import React from 'react';

import {
  annotationsSelectors,
  readerSelectors,
  RootState,
} from '@readcloud/state';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@readcloud/state';
import { filterAnnoByOptions } from '../../utils/annotationUtils';
import { PDFHighlightsRenderer } from './HighlightsRenderer/PDFHighlightsRenderer';

export const ConnectedPDFHighlightsRenderer = (
  props: {
    scale: number;
    pageNumber: number;
    pageContainer: HTMLElement;
    rootContainer: HTMLElement;
  } & Pick<
    React.ComponentProps<typeof PDFHighlightsRenderer>,
    'zIndex' | 'visible'
  >
) => {
  const annotations = useSelector((state: RootState) =>
    annotationsSelectors.getAnnotationByBookAndPage(state, props.pageNumber)
  );

  const selectedAnnotation = useSelector(
    annotationsSelectors.getSelectedAnnotation
  );
  const viewState = useSelector(readerSelectors.getViewState);

  const dispatch = useAppDispatch();

  const filteredAnnotations = React.useMemo(() => {
    return viewState?.annotationFilter && viewState.annotationFilterUsers
      ? annotations.filter((anno) =>
          filterAnnoByOptions(
            anno,
            viewState?.annotationFilter,
            viewState?.annotationFilterUsers
          )
        )
      : annotations;
  }, [
    annotations,
    viewState?.annotationFilter,
    viewState?.annotationFilterUsers,
  ]);

  return (
    <>
      <PDFHighlightsRenderer
        pageNumber={props.pageNumber}
        scale={props.scale}
        visible={props.visible}
        zIndex={props.zIndex}
        annotations={filteredAnnotations}
        selectedAnnotationId={selectedAnnotation?.id}
        annotationPopoverContainer={props.pageContainer}
        height="100%"
        width="100%"
        rootContainer={props.rootContainer}
      />
    </>
  );
};
